export default __webpack_public_path__ + "static/media/banner2.753bc4e9.jpg";